import "./_style.scss";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { useLocation, useNavigate } from "react-router-dom";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import TkStepper from "../../components/atoms/TkStepper";
import { Box } from "@mui/material";
import TkTable from "../../components/atoms/TkTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkButton from "../../components/atoms/TkButton";
import {
  funCorporateInfoBodyList,
  funFacilityInfoBodyList,
} from "./hooks/useHooks";
import {
  contextText,
  corporateInfoHeadTitleList,
  facilityInfoHeadTitleList,
  stepperData,
} from "../SCRC060007/parts";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { httpAPI_CON027, httpAPI_CON028 } from "./api/request";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { Status } from "../../assets/data/Constants";
import { IAPI_CON028_Request } from "../../type/apiType";
import TkInfoManual from "../../components/atoms/TkInfoManual";

/**
 * SCRC060007コンポーネント。
 * @returns JSX.Element
 */
const SCRC060007 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state: businessState } = useContext(BusinessContext);
  const { state, setState } = useContext(GlobalContext);
  const [pramaData, setPramaData] = useState<any>();
  //確認ダイアログ（俸給の調整額登録）のFlug
  const [isNextDialogOpen, setIsNextDialogOpen] = useState(false);
  //申請のflug:true表示、false非表示
  const [issubmitOpen, setIssubmitOpen] = useState(false);
  //機構へ提出のflug:true表示、false非表示
  const [isOpen, setIsOpen] = useState(false);
  //持回情報.一時保存ステップのStepperを状態管理するState
  const [checkAndSubmitstepper, setCheckAndSubmitStepper] = useState<number>();
  const [date, setDate] = useState("");
  const [SCRC060007Data, setSCRC060007Data] = useState<any>({});
  // 機構判定
  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const contractorNo = isKiko
    ? businessState.common?.contractorNo
    : state.authInfo?.contractorNo;
  // ステッパー
  const [step, setStep] = useState(2);
  // ボタン表示
  const [showButton, setShowButton] = useState(true);

  const applyId = location.state?.applyId ?? businessState.job_01?.applyId;

  // 初期化
  const handleInit = async () => {
    // 法人施設職員新規契約情報参照API 呼び出し
    try {
      const res = await httpAPI_CON027({
        applyId: applyId,
      });

      setPramaData(res);

      if (res.resultCd === "I0000") {
        // レスポンスの値からコンポーネント形に変更
        const corporateInfoBodyList = funCorporateInfoBodyList(res);
        const facilityInfoBodyList = funFacilityInfoBodyList(res);

        let data = {
          corporateInfoBodyList: corporateInfoBodyList,
          facilityInfoBodyList: facilityInfoBodyList,
        };
        setSCRC060007Data(data);
        setCheckAndSubmitStepper(businessState.job_01?.tempSaveStep);

        const excludedStatuses = [Status["届出待ち"], Status["差戻し一時保存"]];
        if (!excludedStatuses.includes(res.latestApplyStatus as Status)) {
          setStep(3);
          setShowButton(false);
        } else {
          setStep(2);
          setShowButton(true);
        }

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  //「このまま登録」
  const handleOK = async () => {
    const upData: IAPI_CON028_Request = {
      applyId: applyId,
      contractorNo: contractorNo,
      prefectureCd: pramaData.prefectureCd,
      swFacilityFlg: pramaData.swFacilityFlg,
      swFacilityNum: pramaData.swFacilityNum,
      careFacilityFlg: pramaData.careFacilityFlg,
      careFacilityNum: pramaData.careFacilityNum,
      offerFacilityFlg: pramaData.offerFacilityFlg,
      offerFacilityNum: pramaData.offerFacilityNum,
      joinStaffNumList: pramaData.facilityList.map((item: any) => {
        return {
          facilityNo: item.facilityNo,
          joinStaffNum: item.joinStaffNum,
        };
      }),
    };
    if (isKiko) {
      upData.receptionDate = date;
    }
    try {
      const res = await httpAPI_CON028({
        ...upData,
      });
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        navigate("/SCRC040004", { state: { continueApplyFlg: "1" } });
      } else {
        setIsNextDialogOpen(false);
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  //「契約完了後に登録」
  const handleContractCompletedOK = async () => {
    const upData: IAPI_CON028_Request = {
      applyId: applyId,
      contractorNo: contractorNo,
      prefectureCd: pramaData.prefectureCd,
      swFacilityFlg: pramaData.swFacilityFlg,
      swFacilityNum: pramaData.swFacilityNum,
      careFacilityFlg: pramaData.careFacilityFlg,
      careFacilityNum: pramaData.careFacilityNum,
      offerFacilityFlg: pramaData.offerFacilityFlg,
      offerFacilityNum: pramaData.offerFacilityNum,
      joinStaffNumList: pramaData.facilityList.map((item: any) => {
        return {
          facilityNo: item.facilityNo,
          joinStaffNum: item.joinStaffNum,
        };
      }),
    };
    if (isKiko) {
      upData.receptionDate = date;
    }
    try {
      const res = await httpAPI_CON028({
        ...upData,
      });
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRC070008");
      } else {
        setIsNextDialogOpen(false);
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 機構へ提出
  const handleOrganizationChange = async () => {
    setIsNextDialogOpen(true);
    setIsOpen(false);
  };

  // 申請
  const handleSubmitChange = async (date: any) => {
    setDate(date);
    setIsNextDialogOpen(true);
    setIssubmitOpen(false);
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * @param data フォームのデータ
   */

  return (
    <Box data-testid="SCRC060007PageForTest" className="tkSCRC060007">
      <TkStepper
        steps={stepperData}
        activeStep={step}
        savaStep={checkAndSubmitstepper}
      />
      <Box className="SCRC060007LabelText">
        {isKiko && (
          <TkContractorAndNumberLine
            name="契約者（法人）名"
            no={
              businessState.common?.contractorNo +
              ":" +
              businessState.common?.contractorName
            }
          />
        )}
      </Box>
      <Box>
        <Box className="info">法人情報</Box>
        <TkTable
          headList={corporateInfoHeadTitleList}
          bodyList={SCRC060007Data?.corporateInfoBodyList}
        />
        <Box className="info">施設情報</Box>
        <TkTable
          headList={facilityInfoHeadTitleList}
          bodyList={SCRC060007Data?.facilityInfoBodyList}
        />
      </Box>
      <Box className="tkBottonBox">
        <TkBackButton />
        {showButton && (
          <>
            {isKiko ? (
              <TkButton
                data-testid="organizationButton"
                onClick={() => setIssubmitOpen(true)}
              >
                申請
              </TkButton>
            ) : (
              <TkButton
                data-testid="submitButton"
                onClick={() => setIsOpen(true)}
              >
                機構へ提出する
              </TkButton>
            )}
          </>
        )}
      </Box>
      <Box>
        <TkDateDialog
          open={issubmitOpen}
          onOky={handleSubmitChange}
          onCancel={() => setIssubmitOpen(false)}
          minDate={new Date("1900/01/01")}
          maxDate={new Date()}
          title="確認（申請）"
          contextText="　申請を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
        <TkMessageDialog
          data-testid="TkMessageDialog"
          open={isOpen}
          onOky={handleOrganizationChange}
          onCancel={() => setIsOpen(false)}
          title="確認（機構へ提出する）"
          contextText="　機構へ提出を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
        <TkMessageDialog
          open={isNextDialogOpen}
          onOky={handleOK}
          onCancel={handleContractCompletedOK}
          title="確認（俸給の調整額登録）"
          children={<TkInfoManual rule={"<"}>{contextText}</TkInfoManual>}
          cancelText="契約完了後に登録"
          okText="このまま登録"
        />
      </Box>
    </Box>
  );
};

export default SCRC060007;
